export default __webpack_public_path__ + "static/media/object--bench.de45c74e.png";